import { clientEnv } from '@/shared/config/env';
import { gc987H5Skin } from '@/shared/theme/gc987-h5-skin';
import { lorUsH5Skin } from '@/shared/theme/lor-us-h5-skin';
import { orangeSportsSkin, type SkinManifest } from '@/shared/theme/orange-sports-skin';
import { oroMxH5Skin } from '@/shared/theme/oro-mx-h5-skin';
import type { SkinModule } from '@/shared/theme/skin-module';
import { rosaMxSkinModule } from '@/skins/rosa-mx-h5';

const SITE_SKIN_MAP: Record<string, string> = {
  'gc987-br-h5': 'gc987-h5',
  'lordofriches-us-h5': 'lor-us-h5',
  'orocasino-mx-h5': 'oro-mx-h5',
  'rosacasino-mx-h5': rosaMxSkinModule.code,
  'verdebet-br-web': 'orange-sports',
};

/**
 * B-lite 注册表：只有走 SkinModule 的新皮肤在这里登记；旧 4 套继续用下面的 isXxxSkin 布尔分支。
 * 共享层（AppShell / router / messages / load-theme / mock-bootstrap）对新皮肤只认 `activeSkinModule`。
 */
const SKIN_MODULES: Record<string, SkinModule> = {
  [rosaMxSkinModule.code]: rosaMxSkinModule,
};

const SKIN_BY_CODE: Record<string, SkinManifest> = {
  'gc987-h5': gc987H5Skin,
  'lor-us-h5': lorUsH5Skin,
  'oro-mx-h5': oroMxH5Skin,
  'orange-sports': orangeSportsSkin,
  ...Object.fromEntries(Object.values(SKIN_MODULES).map((module) => [module.code, module.manifest])),
};

const resolveSkinCode = () => {
  if (clientEnv.skinCode) return clientEnv.skinCode;
  return SITE_SKIN_MAP[clientEnv.siteId] ?? 'orange-sports';
};

export const activeSkinCode = resolveSkinCode();

export const activeSkin: SkinManifest = SKIN_BY_CODE[activeSkinCode] ?? orangeSportsSkin;

/** 当前皮肤的 B-lite 模块；旧 4 套皮肤为 null。 */
export const activeSkinModule: SkinModule | null = SKIN_MODULES[activeSkinCode] ?? null;

/** GC987 巴西站皮肤（与 lor-us-h5 互斥、互不依赖）。 */
export const isGc987Skin = activeSkinCode === 'gc987-h5';

/** Lord of Riches 美国站皮肤（与 gc987-h5 完全独立）。 */
export const isLorUsSkin = activeSkinCode === 'lor-us-h5';

/** Oro Casino 墨西哥站皮肤（与 lor-us / gc987 完全独立）。 */
export const isOroMxSkin = activeSkinCode === 'oro-mx-h5';
